// extracted by mini-css-extract-plugin
export var active = "Hero-module--active--2b71a";
export var btnContact = "Hero-module--btnContact--538bb";
export var btnLight = "Hero-module--btnLight--744c6";
export var content = "Hero-module--content--be67e";
export var core = "Hero-module--core--814b8";
export var fixed = "Hero-module--fixed--3ef0d";
export var fixedWrap = "Hero-module--fixedWrap--683e3";
export var hamburger = "Hero-module--hamburger--17c09";
export var overlay = "Hero-module--overlay--61a41";
export var textbox = "Hero-module--textbox--4f3b8";
export var title = "Hero-module--title--7de19";